import useAuth from "~/hooks/auth/useAuth";
import HeaderNoProfile from "~/molecules/headers/HeaderNoProfile";
import HeaderProfile from "~/molecules/headers/HeaderProfile";

const Header = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <HeaderNoProfile />;
  }

  if (!isAuthenticated) {
    return <HeaderNoProfile />;
  }

  return (
    <>
      <HeaderProfile />
    </>
  );
};

export default Header;
